<!-- Main content -->
<section class="content">
  <div class="container-fluid">
   
    <!-- Small boxes (Stat box) -->
    <div class="card-header" style="background-color: white !important;">
      <div class="d-flex justify-content-between">
          <h4 class="font-weight-bold text-dark py">DASHBOARD</h4>
      </div></div>
    <!-- Small boxes (Stat box) -->
    <div class="row">
      <div class="col-lg-6 ">
        <!-- small box -->
        <div class="small-box bg-info">
          <div class="inner">
            <h3>{{student_count}}</h3>

            <p >No. of Student(s)</p>
          </div>
          <div class="icon">
            <i class="ion "></i>
          </div>
          <!-- <a href="#" class="small-box-footer">More info <i class="fas fa-arrow-circle-right"></i></a> -->
        </div>
      </div>
      <!-- ./col -->
      <div class="col-lg-6 ">
        <!-- small box -->
        <div class="small-box bg-success">
          <div class="inner">
            <h3>{{mentor_count}}
              <!-- <sup style="font-size: 20px">%</sup> -->
            </h3>

            <p>No. of Mentor(s)</p>
          </div>
          <div class="icon">
            <i class="ion "></i>
          </div>
          <!-- <a href="#" class="small-box-footer">More info <i class="fas fa-arrow-circle-right"></i></a> -->
        </div>
      </div>
    
    </div>


   
 </div>
</section>
<!-- /.content -->